<div class="login-signin">
  <div class="login-signin-inner">
    <a class="logo-right" [href]="webURL" target="_blank"><img class="logo" [src]='logoURL' alt="VComply"
        onerror="this.src='../assets/images/logo.svg';" /></a>
    <h1 class="login-heading">Sign in to Your VComply Account</h1>
    <h2 class="login-text">Does your organization have an active VComply subscription?
      <a [routerLink]="['/signup']" class="signUp-btn">Click here to sign up and join your team!</a>
    </h2>
    <form novalidate [formGroup]="signInForm" (ngSubmit)="signIn(signInForm)">
      <div class="login-form-item">
        <div class="lable">WORK EMAIL ADDRESS <span class="required">*</span></div>
        <div class="input-area">
          <div *ngIf="currentStep === 2" class="input-box" [class.with-changeBtn]="currentStep === 2"
            [class.disabled]="currentStep ===2" [attr.disabled]="currentStep === 2 ? '' : null">{{email.value}}</div>
          <button *ngIf="currentStep == 2" class="change-btn" type="button" (click)="emailChange()">
            <img class="edit-icon" src="./assets/images/edit-pencil-icon.svg" alt="" />CHANGE
          </button>

          <input *ngIf="currentStep === 1" autocomplete="new-email" (input)="resetErrorState()"
            [class.error-field]="!email.valid && email.touched" (keyup)="checkValidEmail()" (focus)="resetErrorState()"
            type="email" placeholder="Enter your work email address" formControlName="email" id="inputEmail" />

          <div class="error-msg"
            *ngIf="signInForm.get('email').hasError('required') && signInForm.get('email')?.touched">
            <img src="./assets/images/alert-red.svg" alt="" />
            <span>Enter an email address</span>
          </div>
          <div class="error-msg" *ngIf="email.errors?.pattern && email?.touched">
            <img src="./assets/images/alert-red.svg" alt="" />
            <span>Enter a valid email address</span>
          </div>
        </div>
      </div>
      <div class="login-form-item" *ngIf="currentStep === 2">
        <div class="lable">PASSWORD <span class="required">*</span></div>
        <div class="input-area">
          <input appInputTrim autocomplete="current-password" [class.error-field]="!password.valid && password.touched"
            (focus)="resetErrorState()" (input)="resetErrorState()" type="password" placeholder="Enter a password"
            formControlName="password" id="inputPassword" />
          <div class="error-msg"
            *ngIf="signInForm.get('password').hasError('required') && signInForm.get('password').touched">
            <img src="./assets/images/alert-red.svg" alt="" />
            <span>Enter a password</span>
          </div>
          <div class="forget-password">
            <a [routerLink]="['/forgot-password']" [queryParams]="isForceLogin ? { force: 'login' } : null">FORGOT
              PASSWORD?</a>
          </div>
        </div>
      </div>
      <div class="error-text" *ngIf="customError?.hasError" [innerHTML]="customError?.errorMessage | domSanitizer">
      </div>
      <div class="login-form-button">

        <button *ngIf="currentStep == 1" type="button" [disabled]="!email?.value?.length || emailVerifyInProgress"
          (click)="emailVerify()">
          {{emailVerifyInProgress ? 'PLEASE WAIT...' : 'NEXT'}}
          <img src="./assets/images/arrow-right.svg" alt="" />
        </button>

        <button *ngIf="currentStep==2" type="submit" [disabled]="!password?.value?.length || disableSignIn">
          {{disableSignIn ? 'PLEASE WAIT...' : 'SIGN IN'}}
          <img src="./assets/images/arrow-right.svg" alt="" />
        </button>

      </div>
    </form>
    <div class="login-form-bottom-text"><img src="./assets/images/lock-outline.svg" alt="" /> Secured by
      <span>256bits</span> of SSL Encryption
    </div>
    <div class="start-free-trial">
      If you are new to VComply and would like to start a free trial,&nbsp;<a rel="noreferrer"
        href="https://www.v-comply.com/start-free-trial/" target="_blank">click here.</a>
      <br />
      By signing in, you agree to VComply's <a rel="noreferrer" href="https://www.v-comply.com/termsofservice/"
        target="_blank">Terms of Service</a> and <a rel="noreferrer" href="https://www.v-comply.com/privacy/"
        target="_blank">Privacy Policy</a>.
    </div>
  </div>